// contexts/BusinessContext.tsx
'use client';

import { createContext, useContext, useMemo } from 'react';
import type { Business } from '@backoffice/types/Business';
import type { BusinessConfig } from '@tourtask/types/configs/BusinessConfig';

type BusinessWithConfig = Business & { businessConfig: BusinessConfig };

const BusinessContext = createContext<BusinessWithConfig | null>(null);

export const BusinessProvider = ({
  value,
  businessConfig,
  children,
}: {
  value: Business;
  businessConfig: BusinessConfig;
  children: React.ReactNode;
}) => {
  // Keep referential stability to prevent unnecessary rerenders
  const ctxValue = useMemo<BusinessWithConfig>(
    () => ({ ...value, businessConfig }),
    [value, businessConfig]
  );

  return (
    <BusinessContext.Provider value={ctxValue}>
      {children}
    </BusinessContext.Provider>
  );
};

export const useBusiness = () => {
  const ctx = useContext(BusinessContext);
  if (!ctx) throw new Error('useBusiness must be used within a BusinessProvider');
  return ctx;
};